import type { RoutingGuideType } from "~/shared/schemas/routing-guide-schema";

import type { CarrierRule, Rule } from "./types.ts";

export const initialRule: Rule = {
	id: 0,
	condition: "And",
	fieldSelector: "",
	operator: "",
	field1: { label: "", value: "" },
};

export const initialCarrierRule: CarrierRule = {
	id: 0,
	condition: "Or",
	fieldSelector: "",
	operator: "",
	field1: { label: "", value: "" },
};

export const initialGuide: RoutingGuideType = {
	id: 0,
	name: "",
	isActive: false,
	isGlobal: false,
	rules: [initialRule],
	carrier: [initialCarrierRule],
	customerId: null,
	createdDate: new Date().toLocaleDateString(),
	isAutoSelected: false,
	selectionMethod: null,
	isNewGuide: true, // Add a flag to identify new guides
};
